import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Sun, SunDim } from "lucide-react";
import { toast } from "sonner";
import { getFieldMode, setFieldMode } from "@/lib/fieldMode";

// Field Mode: simplified high-contrast sunlight mode (persisted per device).
export default function FieldModeToggle() {
  const { t } = useTranslation();
  const [on, setOn] = useState(getFieldMode);

  useEffect(() => {
    document.documentElement.classList.toggle("hc", on);
  }, [on]);

  const toggle = () => {
    const next = !on;
    setOn(next);
    setFieldMode(next);
    toast.success(next ? t("field_mode_on") : t("field_mode_off"));
  };

  return (
    <button
      data-testid="field-mode-toggle"
      data-active={on}
      onClick={toggle}
      aria-label={t("field_mode")}
      title={t("field_mode")}
      className={`inline-flex min-h-[44px] items-center gap-2 rounded-full border px-3 py-2 text-xs font-semibold uppercase tracking-wider transition-colors active:scale-95 ${
        on
          ? "border-safety bg-safety text-white"
          : "border-slate-300 bg-white text-slate-700 hover:border-slate-400"
      }`}
    >
      {on ? <Sun className="h-4 w-4" /> : <SunDim className="h-4 w-4" />}
      <span className="hidden sm:inline">{t("field_mode")}</span>
    </button>
  );
}
